import { isLastDayOfBusinessWeek } from '@components/workload/calendar/weekly/helpers';
import { addDays, addWeeks, isSunday, lastDayOfMonth, startOfMonth, subDays } from 'date-fns';
import { getFirstDayOfBusinessWeek, getLastDayOfBusinessWeek } from './constants';
import { WorkloadType } from '@components/workload/switch/types';

export const generateDays = (visibleDays: number, date: Date): Date[] => {
  let days = 0;
  return new Array(visibleDays).fill(null).map(() => {
    const newDay = addDays(date, days);
    if (isLastDayOfBusinessWeek(newDay)) days = days + 2;
    else days++;
    return newDay;
  });
};

export const getFirstDay = (date: Date, type?: WorkloadType) => {
  const addIfSunday = (d: Date) => (isSunday(d) ? addDays(d, 1) : d);
  const first = ['two-week', 'week'].includes(type || '') ? date : addIfSunday(startOfMonth(date));
  return getFirstDayOfBusinessWeek(first);
};

export const getLastDay = (date: Date, type?: WorkloadType) => {
  const subIfSunday = (d: Date) => (isSunday(d) ? subDays(d, 1) : d);
  const last = type === 'two-week' ? addWeeks(date, 1) : subIfSunday(lastDayOfMonth(date));
  return getLastDayOfBusinessWeek(last);
};
